module.exports = __webpack_public_path__ + "img/logo_icon.70d49498.png";